import * as React from "react";
import { memo } from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 7.00006L15 12.0001L10 17.0001", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const Memo = memo(SvgArrowRight);
export default Memo;
